import React from "react";
import Nav from './nav';
import "./home.css";
import Carousel1 from "./carousel"
import About from "./about"
import Core from "./core"
import Investment from "./investment";
import InvestmentCalculator from "./calculator"
import Dashboard from "./dash";
import InvestmentsPage from "./opportunities";
import { Routes, Route } from "react-router-dom";
import FloatingContactButtons from "./floating";
import Quick from "./quick";
import Terms from "./terms";
import Feed from "./feed";
import AboutPage from "./aboutextra";


function HomePage() {
  return (
    <div className="home-container">
      
     <Nav />
     <Routes>
        <Route path="/dash" element={<Dashboard />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/inv" element={<InvestmentsPage/>}/>
        <Route path="/terms" element={<Terms/>}/>
        <Route path="/feed" element={<Feed/>}/>
        <Route path="/" element={
          <>
     <Carousel1 />
     <About/>
     <Core />
    <Investment />
    <h1 style={{margin:'20px'}}>Investment Calculator</h1>
    <InvestmentCalculator/>
    <Quick/>
    </>
        }/>
    </Routes>
    <FloatingContactButtons/>
    </div>
  );
}

export default HomePage;
